import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIsMobileDevice } from '../../../../hooks';
import { TDispatch } from '../../../../redux';
import { selectPlacingPeriod } from '../../../../redux/reducers';
import {
  selectActivePeriodId,
  selectIsPeriodAvailable,
  selectFormattedPeriods,
  selectActivePeriod,
} from '../../../../selectors/publishTerms';
import { PlacingPeriodDesktop } from './PlacingPeriod.desktop';
import { PlacingPeriodMobile } from './PlacingPeriod.mobile';
import { getPeriodHint } from './utils';

export const PlacingPeriodContainer = () => {
  const isMobile = useIsMobileDevice();
  const activePeriodId = useSelector(selectActivePeriodId);
  const activePeriod = useSelector(selectActivePeriod);
  const isPeriodAvailable = useSelector(selectIsPeriodAvailable);
  const periods = useSelector(selectFormattedPeriods);
  const dispatch = useDispatch<TDispatch>();

  const hint = getPeriodHint(activePeriod);

  const handleChangePeriod = React.useCallback(
    (newPeriodId: string) => {
      dispatch(selectPlacingPeriod(newPeriodId));
    },
    [dispatch],
  );

  if (!isPeriodAvailable) {
    return null;
  }

  if (isMobile) {
    return (
      <PlacingPeriodMobile
        activePeriodId={activePeriodId}
        periods={periods}
        hint={hint}
        onChangePeriod={handleChangePeriod}
      />
    );
  }

  return (
    <PlacingPeriodDesktop
      activePeriodId={activePeriodId}
      periods={periods}
      hint={hint}
      onChangePeriod={handleChangePeriod}
    />
  );
};
